export enum FileCategory {
  Native = "Native",
  Proxy = "Proxy",
  Copy = "Copy",
  Linked = "Linked",
}
